import { hot } from 'react-hot-loader'
import FormApp from './FormApp'
import ConfigureApp from './ConfigureApp'
import ListingApp from './ListingApp'

const appConfig = {
  Form: FormApp,
  Configure: ConfigureApp,
  Listing: ListingApp
}

export default hot(module)(appConfig)

